import { JSX } from 'react'

import { IconProps } from '../../icon'

const Highlight: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M11.8718 36.3634H16.5159C16.8441 36.3634 17.1559 36.2321 17.3856 36.0023L18.9282 34.4598C19.3549 34.7059 19.8472 34.8372 20.3231 34.8372C20.7661 34.8372 21.1928 34.7388 21.6031 34.5254L24.6061 33.0321C24.9508 33.1634 25.3118 33.2454 25.6892 33.2454C25.722 33.2454 25.7549 33.2454 25.7877 33.2454C26.6082 33.2126 27.3795 32.8352 27.921 32.2116L39.162 19.1654C40.7374 17.3439 40.6718 14.6034 39.0143 12.9459L36.3559 10.2875C34.6984 8.63004 31.9743 8.5644 30.1364 10.1398L17.0902 21.3808C16.4667 21.9223 16.0892 22.71 16.0564 23.5141C16.0564 23.9244 16.122 24.3347 16.2697 24.6957L14.7764 27.6988C14.3333 28.5685 14.399 29.5695 14.8584 30.39L11.002 34.2464C10.6574 34.5911 10.5425 35.1326 10.7395 35.5921C10.9364 36.0516 11.3795 36.347 11.8718 36.347V36.3634ZM20.5036 32.3429C20.3559 32.4249 20.159 32.3921 20.0277 32.2608L17.3856 29.6188L17.0574 29.2906C16.9261 29.1593 16.9097 28.9788 16.9754 28.8147L18.0092 26.7634L22.5549 31.309L20.5036 32.3429ZM18.7149 23.2516L31.761 12.0106C32.6143 11.2721 33.8779 11.2885 34.6328 12.0434L37.2913 14.7018C38.0461 15.4567 38.0461 16.7203 37.3241 17.5736L26.0831 30.6198C25.9518 30.7675 25.8041 30.8003 25.722 30.8003C25.64 30.8003 25.5251 30.8003 25.4267 30.6854L18.6492 23.908C18.5508 23.8095 18.5343 23.6947 18.5508 23.629C18.5508 23.547 18.5836 23.3993 18.7313 23.268L18.7149 23.2516ZM16.5159 32.228L17.0902 32.8023L16.0072 33.8854H14.842L16.5159 32.2116V32.228Z'
      fill='black'
    />
    <path
      d='M39.7692 37.1839H10.2308C9.55795 37.1839 9 37.7418 9 38.4147C9 39.0875 9.55795 39.6454 10.2308 39.6454H39.7692C40.4421 39.6454 41 39.0875 41 38.4147C41 37.7418 40.4421 37.1839 39.7692 37.1839Z'
      fill='black'
    />
  </svg>
)

export default Highlight
